import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center gap-4" }



import Button from 'primevue/button';
import Dialog from 'primevue/dialog';

import { useDeleteCalculation } from '../composables/useDeleteCalculation';


export default /*@__PURE__*/_defineComponent({
  __name: 'CalculationDeleteButton',
  props: {
    calculationId: {}
  },
  setup(__props: any) {

const props = __props;

const { visible, isLoading, deleteCalculation } = useDeleteCalculation(() => props.calculationId);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Dialog), {
      visible: _unref(visible),
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (_isRef(visible) ? (visible).value = $event : null)),
      class: "[&__.p-dialog-header]:pb-2",
      header: "Czy na pewno chcesz usunąć kalkulację?",
      style: { width: '35rem' }
    }, {
      default: _withCtx(() => [
        _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mb-4 text-sm" }, " Ta akcja jest nieodwracalna. Usunięcie kalkulacji spowoduje utratę wszystkich wprowadzonych danych. Czy na pewno chcesz kontynuować? ", -1)),
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_unref(Button), {
            size: "small",
            severity: "secondary",
            outlined: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [
              _createTextVNode(" Anuluj ")
            ])),
            _: 1
          }),
          _createVNode(_unref(Button), {
            size: "small",
            loading: _unref(isLoading),
            onClick: _unref(deleteCalculation)
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" Usuń ")
            ])),
            _: 1
          }, 8, ["loading", "onClick"])
        ])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Button), {
      class: "!p-2",
      size: "small",
      severity: "secondary",
      outlined: "",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (visible.value = true))
    }, {
      default: _withCtx(() => _cache[6] || (_cache[6] = [
        _createElementVNode("i", { class: "pi pi-trash" }, null, -1)
      ])),
      _: 1
    })
  ], 64))
}
}

})